/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';
import client from '@/store/client';

const VUE_APP_VERSION = require('../../package.json').version;

Vue.use(Vuex);

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

const state = {
  VUE_APP_VERSION: process.env.NODE_ENV === 'production' ? `v${VUE_APP_VERSION}` : `v${VUE_APP_VERSION}-dev`,
  user: {
    isVIP: false,
    logged_in: false,
    login_enable: false,
    name: '',
    cell: '',
    email: '',
    sex: '',
    avatar: '',
    savedAddress: [],
  },

  cart: {
  },
  currentOrder: {
    brand: null,
    store: null,
    id: null,
    detail: null,
    delivery: {
      provider: null,
      fee: 0,
      distance: 0,
      freeDelivery: 0,
      discount: 0,
    },
  },
  savedOrders: {},

  currentGroup: {
    brand: null,
    store: null,
    id: null,
    host: null,
    owner: false,
  },

  store: {
    name: '',
    branch: '',
    logo: '',
    banner: '',
    order_setting: {
      announce: '',
    },
    payment: [],
  },
  products: [
    {
      name: '',
      id: '',
      items: [],
    },
  ],
  readOnlyFor: null,
  promos: [],
};

const mutations = {
  SET_USER(state, payload) {
    state.user.logged_in = payload.logged_in;
    state.user.login_enable = payload.login_enable;
    state.user.savedAddress = payload.saved_address;
    state.user.vip_url = payload.vip_url;

    if (state.user.logged_in && state.user.login_enable) {
      state.user.name = payload.user.name;
      state.user.email = payload.user.email;
      state.user.cell = payload.user.cell;
      if (payload.user.sex === 0) {
        state.user.sex = 'female';
      } else if (payload.user.sex === 1) {
        state.user.sex = 'male';
      }
      state.user.avatar = payload.user.head_image;
      state.user.vip = payload.user.vip;
    }
    state.user.actions = payload.actions;
  },
};

const actions = {
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    client,
  },
});
